import { render, staticRenderFns } from "./PaginationSelectComponent.vue?vue&type=template&id=22c7946c&"
import script from "./PaginationSelectComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports